var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from '../button';
var sizeMap = {
    large: 'medium',
    medium: 'small',
};
function ActionButtonInternal(_a, ref) {
    var isUpgrade = _a.isUpgrade, _b = _a.size, size = _b === void 0 ? 'medium' : _b, restProps = __rest(_a, ["isUpgrade", "size"]);
    return (
    // @ts-expect-error: spread props out of sync
    _jsx(Button, __assign({}, restProps, { ref: ref, size: sizeMap[size], variant: isUpgrade ? 'upgrade' : 'plain' })));
}
export default ActionButtonInternal;
